import { createAction } from '@reduxjs/toolkit';

export const setCompanies = createAction('register/set_companies');
export const setCompany = createAction('register/set_company');
export const setUser = createAction('register/set_user');
export const setMode = createAction('register/set_mode');
export const clear = createAction('register/clear');